import { Component, inject } from '@angular/core';
import { PaUploadfileComponent } from 'src/app/shared/ui-kit/pa-uploadfile/pa-uploadfile.component';
import { PaUploadfileButtonComponent } from 'src/app/shared/ui-kit/pa-uploadfile-button/pa-uploadfile-button.component';
import { FormBuilder, FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  standalone: true,
  selector: 'app-uploadfile-view',
  templateUrl: './uploadfile-view.component.html',
  styleUrls: ['./uploadfile-view.component.scss'],
  imports: [PaUploadfileComponent, PaUploadfileButtonComponent, FormsModule, ReactiveFormsModule],
})
export class UploadfileViewComponent {
  allowedFileTypes = '.png,.jpg,.jpeg,.webp,.doc,.docx,.xlsx,.pdf';
  maxSize = 1;

  private fb = inject(FormBuilder);

  form = this.fb.group({
    files: new FormControl([
      {
        added: '2025-08-21 12:00:00',
        mini_image_size: 1231233,
        ext: 'jpg',
        original_name: 'example-image',
        filesize: 1231233,
        uuid: '56b33550-bd6e-4de9-87b0-31b9e3530819',
        type: 'image',
        url: 'https://cdn.pvz-admin.ru/images/25/08/18/978eaad7-ff89-44ca-a49d-5879f8cf149f',
        url_preview: 'https://cdn.pvz-admin.ru/images/25/08/18/978eaad7-ff89-44ca-a49d-5879f8cf149f_x480',
      },
      {
        added: '2025-08-21 12:00:00',
        mini_image_size: null,
        ext: 'pdf',
        original_name: 'pvz-1',
        filesize: 55553,
        uuid: 'ad16e4e5-9da8-472e-9059-5a8dca402930',
        type: 'file',
        url: 'https://cdn.pvz-admin.ru/files/25/08/18/ad16e4e5-9da8-472e-9059-5a8dca402930',
        url_preview: null,
      },
    ]),
    filesButton: new FormControl([]),
  });
}
